export default function prepareActionTypes(
  obj: Record<string, any>,
  result: any[] = []
) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      obj[key] = [...result, key].join('_');
    } else {
      prepareActionTypes(obj[key], [...result, key]);
    }
  });
  return obj;
}
